import React, { FC } from 'react';
import myPostWrapper from '../../../hoc/myPostWrapper';
import PaymentCard from './paymentCard';
import PreferredDeliveryMethod from './preferredDeliveryMethod';
import UserProfile from './userProfile';

interface Props {}

const Settings: FC<Props> = () => {
	return (
		<div>
			<UserProfile />
			<PreferredDeliveryMethod />
			<PaymentCard />
		</div>
	);
};

export default myPostWrapper(Settings);
